import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, FileText, ShieldCheck, CircleCheck, FileCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CollaborativeLiaison() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="collaborative-liaison" className="relative w-full overflow-hidden bg-background py-20 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -z-10 h-[600px] w-[600px] translate-x-1/3 -translate-y-1/4 rounded-full bg-primary/5 blur-3xl" />
      <div className="absolute bottom-0 left-0 -z-10 h-[400px] w-[400px] -translate-x-1/3 translate-y-1/4 rounded-full bg-secondary/5 blur-3xl" />

      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-20 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="w-fit px-3 py-1 text-sm font-medium">
                For Support Coordinators & Plan Managers
              </Badge>
              <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl xl:text-6xl">
                Reliable Partnerships for Better Outcomes
              </h1>
              <p className="max-w-[600px] text-lg text-muted-foreground md:text-xl leading-relaxed">Resolve Clinical Services delivers structured Capacity Building supports under the NDIS, including Therapeutic Supports and Psychosocial Recovery Coaching. We provide goal-directed, evidence-informed interventions with transparent billing and clear reporting to support plan integrity and participant outcomes.</p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row">
              <Button asChild size="lg" className="h-12 px-8 text-base shadow-md">
                <Link to="/ContactPage">
                  Make a Referral
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base bg-background/50 backdrop-blur-sm">
                
              </Button>
            </div>

            
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[500px] lg:max-w-none">
            {}
            <div className="relative z-10 rounded-xl border border-border bg-card/50 p-2 shadow-2xl backdrop-blur-sm">
              <div className="overflow-hidden rounded-lg bg-white">
                 <img src="https://resolveclinicalservices.com.au/wp-content/uploads/2026/02/d95e8662-6863-4591-a3f6-887f72d733d3.png" alt="Warm meeting around a wooden table with papers, no laptop" className="w-full h-auto object-cover" />
              </div>
              
              {}
              

              {}
              <div className="absolute -top-6 -left-6 z-20 hidden sm:block">
                 
              </div>
            </div>

            {}
            <div className="absolute inset-0 -z-10 translate-x-4 translate-y-4 rounded-xl border border-dashed border-primary/20 bg-transparent" />
          </div>
        </div>
      </div>
    </section>;
}